import React, { useRef, useState } from 'react'

/**
 * Drag-and-drop + click image upload component
 * Returns base64-encoded image via onUpload(base64, mediaType)
 */
export function ImageUpload({ onUpload, label, accept = 'image/*', className = '' }) {
  const inputRef = useRef(null)
  const [dragging, setDragging] = useState(false)
  const [preview, setPreview] = useState(null)

  function processFile(file) {
    if (!file) return
    const reader = new FileReader()
    reader.onload = (e) => {
      const dataUrl = e.target.result
      const [meta, base64] = dataUrl.split(',')
      const mediaType = meta.match(/:(.*?);/)[1]
      setPreview(dataUrl)
      onUpload?.(base64, mediaType)
    }
    reader.readAsDataURL(file)
  }

  function handleDrop(e) {
    e.preventDefault()
    setDragging(false)
    processFile(e.dataTransfer.files[0])
  }

  return (
    <div
      className={`relative border-2 border-dashed rounded-xl transition-colors ${dragging ? 'border-emerald-400 bg-emerald-50' : 'border-gray-300 bg-gray-50 hover:border-gray-400'} ${className}`}
      onDragOver={(e) => { e.preventDefault(); setDragging(true) }}
      onDragLeave={() => setDragging(false)}
      onDrop={handleDrop}
      onClick={() => inputRef.current?.click()}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        capture="environment"
        className="hidden"
        onChange={(e) => processFile(e.target.files[0])}
      />
      {preview ? (
        <div className="relative">
          <img src={preview} alt="Preview" className="w-full h-48 object-cover rounded-xl" />
          <button
            type="button"
            className="absolute top-2 right-2 bg-black/50 text-white rounded-full p-1 hover:bg-black/70"
            onClick={(e) => { e.stopPropagation(); setPreview(null); onUpload?.(null) }}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
          <svg className="w-10 h-10 text-gray-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
          </svg>
          <p className="text-sm text-gray-500">{label || 'Glisser une photo ou cliquer pour choisir'}</p>
          <p className="text-xs text-gray-400 mt-1">PNG, JPG, WEBP</p>
        </div>
      )}
    </div>
  )
}
